
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M11.79 23.71h16.55M31.65 23.71H40M0 23.71h8.35M7.42 33.92V1.26h5.17v32.66"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M6 33.56h8v5.17H6zM27.41 32.96V1.26h5.18v31.7M26 33.56h8v5.17h-8zM27.4 3.69a7.4 7.4 0 11-14.8 0M40 11.27a7.49 7.49 0 01-7.4-7.58M0 11.27a7.49 7.49 0 007.4-7.58M20 12.04v11.84"}})])
          )
        }
      }
    